export default __webpack_public_path__ + "static/media/fastest_delivery.0de6c433.svg";